export const homeVideoPreviews: Record<
  string,
  { src: string; poster: string; audio?: boolean }
> = {
  "/videos/home-hero-fashion-website-film.mp4": {
    src: "/videos/previews/home-hero-1.mp4",
    poster: "/videos/previews/home-hero-1.webp",
  },
  "/videos/home-hero-models-walking-architecture.mp4": {
    src: "/videos/previews/home-hero-2.mp4",
    poster: "/videos/previews/home-hero-2.webp",
  },
  "/videos/video-editing-commercial-hero-fashion-film.mp4": {
    src: "/videos/previews/about-studio.mp4",
    poster: "/videos/previews/about-studio.webp",
  },
  "/videos/video-editing-wall-autumn-editorial-montage.mp4": {
    src: "/videos/previews/services-intro.mp4",
    poster: "/videos/previews/services-intro.webp",
  },
  "/videos/home-fashion-editorial-montage.mp4": {
    src: "/videos/previews/ai-image-workflow.mp4",
    poster: "/videos/previews/ai-image-workflow.webp",
  },
  "/videos/home-fashion-ecommerce-montage.mp4": {
    src: "/videos/previews/photo-editing.mp4",
    poster: "/videos/previews/photo-editing.webp",
  },
  "/videos/video-editing-wall-featured-campaign.mp4": {
    src: "/videos/previews/video-editing.mp4",
    poster: "/videos/previews/video-editing.webp",
  },
  "/videos/video-editing-wall-botanical-skincare-motion.mp4": {
    src: "/videos/previews/3d-cgi.mp4",
    poster: "/videos/previews/3d-cgi.webp",
  },
  "/videos/video-editing-wall-resort-collection-film.mp4": {
    src: "/videos/previews/commercial-editing.mp4",
    poster: "/videos/previews/commercial-editing.webp",
  },
  "/videos/video-editing-wall-activewear-studio-motion.mp4": {
    src: "/videos/previews/fashion-lifestyle.mp4",
    poster: "/videos/previews/fashion-lifestyle.webp",
  },
  "/videos/home-luxury-cosmetic-advertising.mp4": {
    src: "/videos/previews/cosmetics-film.mp4",
    poster: "/videos/previews/cosmetics-film.webp",
  },
  "/videos/home-filming-luxury-beauty-product.mp4": {
    src: "/videos/previews/beauty-film.mp4",
    poster: "/videos/previews/beauty-film.webp",
    audio: true,
  },
  "/videos/stage-3-master-grade.mp4": {
    src: "/videos/previews/master-grade.mp4",
    poster: "/videos/previews/master-grade.webp",
  },
  "/videos/video-editing-ai-motion-synthesis.mp4": {
    src: "/videos/previews/fashion-motion.mp4",
    poster: "/videos/previews/fashion-motion.webp",
  },
};

import { mediaUrl } from "$lib/utils/media";

export function getHomeVideoPreview(src: string) {
  const item = homeVideoPreviews[src];
  if (item) {
    return {
      src: mediaUrl(item.src),
      poster: item.poster ? mediaUrl(item.poster) : undefined,
      audio: item.audio,
    };
  }
  return { src: mediaUrl(src), poster: undefined };
}

